export const CLOSE_INFO_PANE = 'CLOSE_INFO_PANE';
export const OPEN_INFO_PANE = 'OPEN_INFO_PANE';
export const SET_INFO_PANE_DATA = 'SET_INFO_PANE_DATA';
export const SET_INFO_PANE_STATE = 'SET_INFO_PANE_STATE';
